export const LINKTABLECOLUMNSALL_REQUEST = "LINKTABLECOLUMNSALL_REQUEST";
export const LINKTABLECOLUMNSALL_SUCCESS = "LINKTABLECOLUMNSALL_SUCCESS";
export const LINKTABLECOLUMNSALL_FAIL = "LINKTABLECOLUMNSALL_FAIL";